import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-build-version',
  templateUrl: './build-version.component.html',
  styleUrls: ['./build-version.component.scss']
})
export class BuildVersionComponent implements OnInit {

  public buildVersionString: string;

  constructor(private httpClient: HttpClient) {
    this.httpClient.get('assets/versioning/CPSAngularVersion.txt', { responseType: 'text' })
    .subscribe(txt => {
      this.buildVersionString = txt;
      console.log("Client Version: " + txt);
    });
  }

  ngOnInit(): void {
  }

}
